const valueToName = (list, value) => {
  const item = list.find(item => {
    return item.value === value;
  });

  return item ? item.name : null;
};

export default valueToName;
